import { render, staticRenderFns } from "./CompanyLink.vue?vue&type=template&id=45607d9f"
import script from "./CompanyLink.vue?vue&type=script&lang=ts"
export * from "./CompanyLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports